// extracted by mini-css-extract-plugin
export default {"rating":"FB-z","numberOfStars":"GB-z","count":"HB-z","barGraphSpacing":"IB-z","barGraph":"JB-z"};